import React, { FC } from "react"
import { Link } from "@reach/router"
import styled from "styled-components"
import { LazyLoadImage } from "react-lazy-load-image-component"

const StyledBlogPost = styled.span`
  display: block;
  box-shadow: 0 10px 30px 0 rgba(0, 39, 90, 0.2);
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  :hover {
    transform: scale(1.01);
  }
  img {
    width: 100%;
    max-height: 10rem;
    object-fit: cover;
    display: block;
  }
  .meta {
    display: block;
    padding: 1.5rem;
    color: ${({ theme }) => theme.colors.obsidian};
    .description {
      color: ${({ theme }) => theme.colors.obsidian};
    }
  }
`

interface IBlogPost {
  slug: string
  heroSrc: string
  heroAlt: string
  title: string
  description: string
}

const BlogPost: FC<IBlogPost> = props => (
  <Link to={`/blog/${props.slug}`}>
    <StyledBlogPost>
      <LazyLoadImage src={props.heroSrc} alt={props.heroAlt} />
      <span className="meta">
        <h5 className="title">{props.title}</h5>
        <p className="description">{props.description}</p>
      </span>
    </StyledBlogPost>
  </Link>
)

export default BlogPost
